export type MfaData = {
  type: MfaOption
  code: string
  phone: string
}

export enum MfaOption {
  TOTP = 'totp',
  SMS = 'sms',
  // legacy
  APP = 'app',
}
